import React from "react";
import RtrImage from "../shared/rtr-image";
import type { ShortlistImagesProps } from "./types";

const ShortlistImages = ({ images }: ShortlistImagesProps) => {
  const imageList = images || [];

  return (
    <div className="flex h-16 w-24 overflow-hidden rounded-lg">
      <div className="flex h-[76px] w-[110px] rounded-lg overflow-hidden">
        <div className="w-2/3 pr-[2px]">
          {imageList[0] ? (
            <RtrImage
              className="h-full w-full object-cover object-top brightness-[0.95]"
              alt={"Shortlist Image 1"}
              src={imageList[0]}
            />
          ) : (
            <div className="h-full w-full bg-offWhite" />
          )}
        </div>

        <div className="flex flex-col w-1/3">
          <div className="h-1/2 pb-[2px]">
            {imageList[1] ? (
              <RtrImage
                className="h-full w-full object-cover object-top brightness-[0.95]"
                alt={"Shortlist Image 2"}
                src={imageList[1]}
              />
            ) : (
              <div className="h-full w-full bg-offWhite" />
            )}
          </div>

          <div className="h-1/2">
            {imageList[2] ? (
              <RtrImage
                className="h-full w-full object-cover object-top brightness-[0.95]"
                alt={"Shortlist Image 3"}
                src={imageList[2]}
              />
            ) : (
              <div className="h-full w-full bg-offWhite" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShortlistImages;
